import {
  Befehl24FormData,
  Befehl24FormSchema
} from './schema/befehl24-form.schema'
import { Befehl24 } from '../../../models'
import {
  Befehl24DataDto,
  BefehlAuftrag_24_11Dto,
  BefehlAuftrag_24_12Dto,
  Feld_24_13Dto,
  Feld_24_14Dto,
  Feld_24_15Dto,
  Feld_24_16Dto
} from '../../../dtos/befehl-24-dto'
import { BefehlAuftragDto } from '../../../dtos'
import { findAuftragByKennung, hasAuftrag } from '../converter-utils'

export const convertModelToBefehl24FormData = (
  befehl: Befehl24 | undefined
): Befehl24FormData => {
  const formData = Befehl24FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  // Extract field data from an auftrag
  const extractFieldData = (auftrag: BefehlAuftragDto) => {
    for (const feld of auftrag.felder) {
      switch (feld.kennung) {
        case '24.13': {
          const feld24_13 = feld as Feld_24_13Dto
          formData.auftrag_24_11_12_fields.feld24_13 = {
            art: feld24_13.werte?.zugmeldestelle.art || '',
            name: feld24_13.werte?.zugmeldestelle.name || ''
          }
          break
        }
        case '24.14': {
          const feld24_14 = feld as Feld_24_14Dto
          formData.auftrag_24_11_12_fields.feld24_14 = {
            art: feld24_14.werte?.zugmeldestelle.art || '',
            name: feld24_14.werte?.zugmeldestelle.name || ''
          }
          break
        }
        case '24.15': {
          const feld24_15 = feld as Feld_24_15Dto
          formData.auftrag_24_11_12_fields.feld_24_15_16_type = 'km'
          formData.auftrag_24_11_12_fields.feld_24_15_km = feld24_15.werte.km
          break
        }
        case '24.16': {
          const feld24_16 = feld as Feld_24_16Dto
          formData.auftrag_24_11_12_fields.feld_24_15_16_type = 'signal'
          formData.auftrag_24_11_12_fields.feld_24_16_signal =
            feld24_16.werte.signal ?? ''
          break
        }
      }
    }
  }

  if (hasAuftrag(befehl.auftraege, '24.11')) {
    formData.auftrag_24_11.enabled = true
  }

  if (hasAuftrag(befehl.auftraege, '24.12')) {
    formData.auftrag_24_12.enabled = true
  }

  if (hasAuftrag(befehl.auftraege, '24.20')) {
    formData.auftrag_24_20.enabled = true
  }

  if (hasAuftrag(befehl.auftraege, '24.30')) {
    formData.auftrag_24_30.enabled = true
  }

  const auftrag24_11 = findAuftragByKennung(befehl.auftraege, '24.11')
  const auftrag24_12 = findAuftragByKennung(befehl.auftraege, '24.12')

  if (auftrag24_11) extractFieldData(auftrag24_11)
  if (auftrag24_12) extractFieldData(auftrag24_12)

  return formData
}

export const convertBefehl24FormDataToModel = (
  data: Befehl24FormData,
  frontendId: string
): Befehl24 => {
  const auftraege: Befehl24DataDto = []

  if (data.auftrag_24_11?.enabled || data.auftrag_24_12?.enabled) {
    const kennung = data.auftrag_24_11?.enabled ? '24.11' : '24.12'

    const fields: Array<
      Feld_24_13Dto | Feld_24_14Dto | Feld_24_15Dto | Feld_24_16Dto
    > = [
      {
        kennung: '24.13',
        werte: {
          zugmeldestelle: {
            art: data.auftrag_24_11_12_fields?.feld24_13?.art || '',
            name: data.auftrag_24_11_12_fields?.feld24_13?.name || ''
          }
        }
      } as Feld_24_13Dto,
      {
        kennung: '24.14',
        werte: {
          zugmeldestelle: {
            art: data.auftrag_24_11_12_fields?.feld24_14?.art || '',
            name: data.auftrag_24_11_12_fields?.feld24_14?.name || ''
          }
        }
      } as Feld_24_14Dto
    ]

    if (data.auftrag_24_11_12_fields?.feld_24_15_16_type === 'km') {
      fields.push({
        kennung: '24.15',
        werte: { km: data.auftrag_24_11_12_fields?.feld_24_15_km || '' }
      } as Feld_24_15Dto)
    } else if (data.auftrag_24_11_12_fields?.feld_24_15_16_type === 'signal') {
      fields.push({
        kennung: '24.16',
        werte: { signal: data.auftrag_24_11_12_fields?.feld_24_16_signal || '' }
      } as Feld_24_16Dto)
    }

    auftraege.push({
      kennung: kennung,
      felder: fields
    } as BefehlAuftrag_24_11Dto | BefehlAuftrag_24_12Dto)
  }

  if (data.auftrag_24_20?.enabled) {
    auftraege.push({
      kennung: '24.20',
      felder: []
    })
  }

  if (data.auftrag_24_30?.enabled) {
    auftraege.push({
      kennung: '24.30',
      felder: []
    })
  }

  return {
    kennung: '24',
    frontendId,
    auftraege
  }
}
